import React from 'react';

const ErrorIcon = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.0007 2.83301C9.16648 2.83301 2.83398 9.16551 2.83398 16.9997C2.83398 24.8338 9.16648 31.1663 17.0007 31.1663C24.8348 31.1663 31.1673 24.8338 31.1673 16.9997C31.1673 9.16551 24.8348 2.83301 17.0007 2.83301ZM24.084 22.0855L22.0865 24.083L17.0007 18.9972L11.9148 24.083L9.91732 22.0855L15.0032 16.9997L9.91732 11.9138L11.9148 9.91634L17.0007 15.0022L22.0865 9.91634L24.084 11.9138L18.9981 16.9997L24.084 22.0855Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default ErrorIcon;
